// src/features/agent-builder/components/AIInsightsTeaser.tsx
import React from 'react';
import { useTranslation } from 'react-i18next';
import { ToggleSwitchField, Tooltip } from '@dopomogai/ui';
import { renderIcon } from '@dopomogai/utils';
// clsx import was here but not used, can be removed if not needed for other parts.
// import clsx from 'clsx';

const PlaceholderChart = () => (
  <div className="w-full h-48 bg-slate-200 border border-slate-300 rounded-md flex items-center justify-center animate-pulse">
    <div className="text-slate-400">
      {renderIcon('barchart', { size: 48, strokeWidth: 1.5 })}
    </div>
  </div>
);


export const AIInsightsTeaser: React.FC = () => {
  const { t } = useTranslation('agentBuilder');

  return (
    <div className="p-6 md:p-8 text-center">
      <div className="inline-flex items-center justify-center p-4 mb-5 bg-gradient-to-br from-teal-500 to-emerald-600 rounded-full shadow-lg">
        {renderIcon('activity', { size: 36, className: "text-white" })}
      </div>
      <h3 className="text-xl sm:text-2xl font-bold text-gray-800 mb-2">
        {t('step5.aiInsights.title')}
      </h3>
      <p className="text-sm sm:text-base text-gray-600 max-w-xl mx-auto mb-6 leading-relaxed">
        {t('step5.aiInsights.description')}
      </p>

      <div className="my-8 opacity-60">
        <PlaceholderChart />
      </div>

      <div className="mt-8 flex flex-col items-center">
        <Tooltip
          textKey="agentBuilder:step5.aiInsights.enableTooltip"
          position="top"
        >
          {/* Corrected: Wrap ToggleSwitchField in a div for styling if className is not supported directly */}
          <div className="w-full max-w-xs opacity-70 cursor-not-allowed justify-center flex"> {/* Added flex and justify-center here */}
            <ToggleSwitchField
              id="ai-analyst-toggle-teaser"
              labelKey="agentBuilder:step5.aiInsights.enableToggle"
              labelPosition="right"
              checked={false}
              disabled
              onChange={() => {}}
              // className="justify-center" // Removed from ToggleSwitchField
              // If ToggleSwitchField has specific props for container styling, use those.
              // e.g., containerClassName="justify-center"
            />
          </div>
        </Tooltip>
         <p className="mt-2 text-xs text-slate-500">
            {t('step5.aiInsights.comingSoonNote')}
        </p>
      </div>
    </div>
  );
};